import { Transaction } from 'types';

export const getTransactionSharesCount = (transaction: Transaction) => {
  if (!transaction) return 0;

  const sharesCount =
    transaction?.sharesCount || transaction.shareTo - transaction.shareFrom + 1;

  return sharesCount;
};
